// extracted by mini-css-extract-plugin
export var aggregationCell = "_20-k";
export var aggregationRow = "_20-j";
export var borderlessSpinnerContainer = "_20-3";
export var closeIcon = "_20-c";
export var columnHeaderSurface = "_20-8";
export var columnHeaderSurfaceDragOverlay = "_20-s";
export var columnHeaderSurfaceResizing = "_20-p";
export var contextMenuAnchor = "_20-1";
export var draggableColumnHeader = "_20-q";
export var draggableColumnHeaderOverlay = "_20-r";
export var expandIcon = "_20-d";
export var expanded = "_20-e";
export var filterDropdown = "_20-f";
export var filterDropdownDivider = "_20-a";
export var filterDropdownHeader = "_20-i";
export var filterDropdownItem = "_20-h";
export var filterDropdownModal = "_20-g _20-f";
export var filterItem = "_20-9";
export var normalCellWithAdjustableBorder = "_20-b";
export var pinButtonContainer = "_20-l";
export var pinIcon = "_20-m";
export var pinIconActive = "_20-n";
export var spinner = "_20-0";
export var spinnerContainer = "_20-2";
export var tableContainer = "_20-4";
export var tableContentDraggingColumns = "_20-7";
export var tableContentInner = "_20-6";
export var tableContentWrapper = "_20-5";
export var viewButtonContainer = "_20-o";